import styled from 'styled-components';

const StyledBlogTheme = styled.div`
  background-color: white;
  color: #222;
  min-height: 100vh;
`;

export const BlogTheme = ({ children }) => {
  return <StyledBlogTheme>{children}</StyledBlogTheme>;
};
